import React from "react";
import Button from "../UI/Button";
import { Grid, Paper, Typography } from "@mui/material";
import Container from "../UI/Container";
import { Link } from "react-router-dom";

const CatracaRegistroMenu = () => {
  return (
    <Container component={Paper}>
      <Grid container direction="column" spacing={3}>
        <Grid size={12}>
          <Typography variant="h5">Monitor de Acesso</Typography>
        </Grid>
        <Grid>
          <Grid container spacing={3} direction="row">
            <Grid>
              <Button
                component={Link}
                to={{
                  pathname: "/monitor-acesso",
                }}
              >
                Monitor de Acesso por Aluno
              </Button>
            </Grid>
            <Grid>
              <Button
                component={Link}
                to={{
                  pathname: "/monitor-acesso-check",
                }}
              >
                Monitor de Acesso por Turma e Data
              </Button>
            </Grid>
            <Grid>
              <Button
                component={Link}
                to={{
                  pathname: "/monitor-acesso-lista",
                }}
              >
                Monitor de Acesso Lista
              </Button>
            </Grid>
            <Grid>
              <Button
                component={Link}
                to={{
                  pathname: "/monitor-acesso-contador",
                }}
              >
                Monitor de Acesso Contador
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default CatracaRegistroMenu;
